import { jsx as s } from "react/jsx-runtime";
import o from "clsx";
import { camelCase as r } from "lodash";
const i = "_6d32352", c = "_037dc60", m = "_5e34a51", f = "_a11dae0", y = "_bd99ca7", n = {
  info: i,
  typeInfo: c,
  typeConfirmation: m,
  typeError: f,
  typeWarning: y
}, L = ({ type: t = "info", className: a, children: e }) => /* @__PURE__ */ s(
  "div",
  {
    className: o(
      n.info,
      n[r(`type-${t}`)],
      a
    ),
    children: e
  }
), l = "_32b5e3e", p = {
  starsLink: l
}, N = (t) => /* @__PURE__ */ s("a", { ...t, className: o(p.starsLink, t.className), children: t.children });
export {
  L as StarsInfo,
  N as StarsLink
};
